var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M69.957 39.87c0 16.569-13.431 30-30 30-16.568 0-30-13.431-30-30 0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30M37.351 24.555a7.513 7.513 0 0 0-7.513 7.513c0 4.179 3.01 7.513 7.513 7.513 2.569 0 4.668.162 6.543.803 1.904.651 3.502 1.768 5.127 3.549 1.73 1.894 2.47 4.424 2.795 6.384a20 20 0 0 1 .26 3.263q-.002.136-.005.212l-.002.058v.026l-1-.05 1 .05a1 1 0 0 1-1 .95H29.833a1 1 0 0 1 0-2h20.232a18 18 0 0 0-.222-2.182c-.3-1.808-.952-3.888-2.299-5.363-1.45-1.588-2.776-2.484-4.297-3.004-1.552-.53-3.38-.697-5.896-.697-5.667 0-9.513-4.289-9.513-9.512a9.513 9.513 0 1 1 17.512 5.151 1 1 0 0 1-1.681-1.084 7.513 7.513 0 0 0-6.318-11.58",
    clipRule: "evenodd"
  })));
};
export default SvgIcon;